module.exports = __webpack_public_path__ + "img/simulator.d9e2d262.jpg";